<template lang="html">
	<div class="omapi-subscribers-page omapi-subscribers-segments">
		<monsterleads-segments-no-segments v-if="!hasTags" />
		<monsterleads-segments-table v-else />
	</div>
</template>

<script lang="js">
import { mapState } from 'vuex';

export default {
	computed: {
		...mapState('monsterleads', ['count']),
		hasTags() {
			return 0 < this.count;
		},
	},
};
</script>
<style lang="scss">
@import '../../assets/scss/variables';
</style>
